import React, { useEffect, useState } from "react";
import './iframe.css'
import data from './data.json'
import GlobalCTA from './globalCTA'

const ANetLogin = (props) => {
  const [isInitialLoad, setInitialLoad] = useState(true)
// anet api
// https://dev.caas.athenahealth.com/athenanetapi/--anet--test-athenaet-page?_format=json&preview=latest&cache=clear
  useEffect(() => {
    if (window && document && document.referrer) {
      
    let checkHelp =  document.querySelectorAll('[name="frHelp"]')
     if(checkHelp && checkHelp.length > 0){
       checkHelp[0].contentWindow.postMessage('LOGIN_BRANDING_CONTENT_LOADED', "*")
     }
      window.top.postMessage('LOGIN_BRANDING_CONTENT_LOADED', document.referrer);
    }

    function makelongshadow(color='#160F41', length, hOffset=-1, vOffset=1){
      let val = '0px 0px' + color
      for (let index = 1; index <= length; index++) {
        val += `, ${index * hOffset}px ${index * vOffset}px ${color}`
      }
      return val;
    }

    // generates the shadow for the heading tag with shadow variant
    let variant = athenaNetCard && athenaNetCard.variant ? athenaNetCard.variant : 'shadow';
    if(variant == 'shadow' && isInitialLoad){
      let heading = document.getElementById('title-container');
      let cloneHeading = heading.childNodes[0].cloneNode(true);
      heading.appendChild( cloneHeading );
      heading.childNodes[0].style.textShadow = makelongshadow('#160F41',800,-0.8,-1);
    }
    setInitialLoad(false);
  },[]);

  const [dataComponentName, setdataComponentName] = useState('AthenaNet Login');
  let pagedata = data.pagedata.custom_blocks[1].data
  let isWindows = navigator.appVersion.indexOf("Win") != -1;
  let imageWidth = isWindows ? "80%": 'auto;'
  let athenaNetCard = pagedata && pagedata.athenanet_card_component ? pagedata.athenanet_card_component : null
  //variant -> shadow | text | text_plus_image 
  let bannerVariant = athenaNetCard.variant ? athenaNetCard.variant : 'shadow'; 
  let title = athenaNetCard && athenaNetCard.title ? athenaNetCard.title : '';
  // shadow variant -> banner-headline-1 | banner-headline-2 | banner-headline-3 |
  // text | text_plus_image variant ->  xxl-head | xl-head | l-head | m-head
  let titleTypeCls = athenaNetCard && athenaNetCard.title_type ? `${athenaNetCard.title_type}-sspro` : '';
  let subTitle = athenaNetCard && athenaNetCard.sub_title ? athenaNetCard.sub_title : ''
  let description = athenaNetCard && athenaNetCard.description ? athenaNetCard.description : '';
  // desc styles -> xl-head | l-head | m-head | m-head
  let descTypeCls = athenaNetCard && athenaNetCard.description_type ? `${athenaNetCard.description_type}-sspro` : '';
  let backColor = athenaNetCard && athenaNetCard.field_background_color ? athenaNetCard.field_background_color : '';

  let imgSrc = athenaNetCard && athenaNetCard.image && athenaNetCard.image.image_name ? athenaNetCard.image.image_name : ''
  // let imgUrl = athenaNetCard && athenaNetCard.image && athenaNetCard.image.rel_url ? athenaNetCard.image.rel_url : ''

  let itemCtaStyle = athenaNetCard?.field_cta_link_component?.field_cta_style?.field_cta_size[0].value ?? '',
    itemCtaLink = athenaNetCard && athenaNetCard.field_cta_link_component ? athenaNetCard.field_cta_link_component.field_cta_link.link : '',
    itemCtaLabel = athenaNetCard && athenaNetCard.field_cta_link_component ? athenaNetCard.field_cta_link_component.field_cta_link.label : '',
    itemCtaType = athenaNetCard && athenaNetCard.field_cta_link_component && athenaNetCard.field_cta_link_component.field_carousel_cta_type !== '' ? 'Link' : '',
    itemFormID = athenaNetCard && athenaNetCard.field_cta_link_component && athenaNetCard.field_cta_link_component.field_carousel_gated_form ? athenaNetCard.field_cta_link_component.field_carousel_gated_form.value : '',
    itemVideoID = athenaNetCard && athenaNetCard.field_cta_link_component && athenaNetCard.field_cta_link_component.field_cta_brightcove_video && athenaNetCard.field_cta_link_component.field_cta_brightcove_video.video_id[0] ? athenaNetCard.field_cta_link_component.field_cta_brightcove_video.video_id[0].value : '',
    ctaLinkTarget = athenaNetCard && athenaNetCard.open_link_new_tab && athenaNetCard.open_link_new_tab == 1 ? "_blank":'';

  let ahnlDetails = title || subTitle || description || itemCtaType ? "ahnl-details" : ''
  let ahnlDetailDisplay = !title && !subTitle && !description && !itemCtaType ? 'none' : ''
  let imageMargin = ahnlDetailDisplay ? 'auto' : ''
  let backgroundStyle =  bannerVariant === 'text_plus_image' ? `url("${imgSrc}") center / cover no-repeat` : backColor;
  return (
    <div style={{ 
      background: backgroundStyle
      }} className={`ahnl-wrapper ${bannerVariant}`}>
      <div className={ahnlDetails} style={{ display: ahnlDetailDisplay }}>
        {subTitle && <div className="ahnl-subtitle subhead-1" dangerouslySetInnerHTML={{ __html: subTitle }}></div>}
        {title && <div id="title-container" className={`ahnl-title ${titleTypeCls}`} dangerouslySetInnerHTML={{ __html: title }}></div>}
        {description && <div className={`ahnl-description ${descTypeCls}`} dangerouslySetInnerHTML={{ __html: description }}></div>}

        {itemCtaType &&
          <div className="ahnl-cta">
          <GlobalCTA ctaType={itemCtaType} 
            ctaUrl={itemCtaLink} 
            ctaLabel={itemCtaLabel} 
            ctaStyle={itemCtaStyle} 
            ctaFormID={itemFormID} 
            ctaVideoID={itemVideoID} 
            dataComponentName={dataComponentName} 
            dataMachineName="athenanet_card_component" 
            ctaLinkTarget={ctaLinkTarget}/>
             {/* <a id="g_cta" className={itemCtaStyle} href={itemCtaLink} target={ctaLinkTarget}>{itemCtaLabel}</a> */}
          </div>
        }
      </div>
      {imgSrc && bannerVariant != 'text_plus_image' && <div className="ahnl-img-wrapper" style={{ margin: imageMargin }}>
        <img className="ahnl-img-container" style={{width:imageWidth}} src={imgSrc} alt={athenaNetCard.image.options.alt ? athenaNetCard.image.options.alt : ''} />
      </div>}

    </div>
  )
}

export default ANetLogin;
